require('./teamInfoManagerService');

"use strict";

angular.module('app.admin.teamInfoManager.teamInfoManagerController', [
  'app.admin.teamInfoManager.teamInfoManagerService'
])
  .controller('app.admin.teamInfoManager.teamInfoManagerController', [
    '$scope',
    '$state',
    'app.admin.teamInfoManager.teamInfoManagerService',
    function ($scope, $state,  teamInfoManagerService) {
      $scope.teamInfo = null;
      $scope.boolSelector = [
        {
          label: '-- Select One --',
          value: ''
        },
        {
          label: 'No',
          value: 0
        },
        {
          label: 'Yes',
          value: 1
        }
      ];
      $scope.inetTypes = [
        {
          label: '-- Select One --',
          value: ''
        },
        {
          label: 'Fibre',
          value: 'Fibre'
        },
        {
          label: 'Cable',
          value: 'Cable'
        },
        {
          label: 'T1/Bonded T1',
          value: 'T1/Bonded T1'
        },
        {
          label: 'DSL',
          value: 'DSL'
        },
        {
          label: 'Unknown',
          value: 'Unknown'
        }
      ];

      let init = () => {
        teamInfoManagerService.getTeams()
          .then((response) => {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            } else {
              $scope.teams = data;
            }
          });
      };

      $scope.loadTeamInfo = () => {
         teamInfoManagerService.retrieve($scope.selectedTeam)
          .then((response) => {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else {
              $scope.teamInfo = data;
            }
          });
      };

      $scope.goToPassManager = () => {
        $state.go('app.admin.passManager', { teamId: $scope.selectedTeam });
      };

      $scope.saveContact = (index) => {
        teamInfoManagerService.saveContact($scope.teamInfo.fh_team_id_c, $scope.teamInfo.contacts[index])
          .then((response) => {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else {
              $scope.teamInfo.contacts[index] = data;
            }
          })
      };

      $scope.saveAccount = () => {
        teamInfoManagerService.saveAccount($scope.teamInfo.fh_team_id_c, $scope.teamInfo.account)
          .then((response) => {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else {
              $scope.teamInfo.account = data;
            }
          })
      };

      $scope.saveAccountCstm = () => {
        let teamInfo = _.clone($scope.teamInfo);
        _.unset(teamInfo,'account');
        _.unset(teamInfo,'contacts');

        teamInfoManagerService.saveAccountCstm(teamInfo)
          .then((response) => {
            let data = response.data;

            if (data.error) {
              alert(data.error);
            }
            else {
              let contacts = angular.copy($scope.teamInfo.contacts);
              let account = angular.copy($scope.teamInfo.account);

              $scope.teamInfo = data;
              $scope.teamInfo.contacts = contacts;
              $scope.teamInfo.account = account;
            }
          })
      };

      init();
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/admin/teamInfoManager/teamInfoManagerController.js